export function emailValidation(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function inputValidation(value: string) {
  return value.trim().length > 0;
}
